<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
    <el-tab-pane label="社保账单" name="社保账单" v-if="checkPermission(['socialBill'], this.permissionLists)"></el-tab-pane>
    <el-tab-pane label="账单导入" name="账单导入" v-if="checkPermission(['importBill'], this.permissionLists)"></el-tab-pane>
    <el-tab-pane label="缴费标准" name="缴费标准" v-if="checkPermission(['payFees'], this.permissionLists)"></el-tab-pane>
    <el-tab-pane label="社保设置" name="社保设置" v-if="checkPermission(['socialSet'], this.permissionLists)"></el-tab-pane>
  </el-tabs>
</template>
<script>
  import xz from "./../../../common.vue";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activeName: '社保账单',
        permissionLists: [],
      }
    },
    created() {
      if (this.$route.query.active != undefined && this.$route.query.active) {
        this.activeName = this.$route.query.active
      }
      this.getButtonPower();
      // 向父组件传值
      this.$emit('change', this.activeName);
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/socialBill',
          powerEnName: 'socialBill'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      handleClick(tab) {
        // 向父组件传递了两个值
        if (tab.name == '社保账单') {
          this.$router.push({
            path: '/socialBill?active=社保账单'
          })
        } else if (tab.name == '账单导入') {
          this.$router.push({
            path: '/importBill?active=账单导入'
          })
        } else if (tab.name == '缴费标准') {
          this.$router.push({
            path: '/payFees?active=缴费标准'
          })
        } else if (tab.name == '社保设置') {
          this.$router.push({
            path: '/socialInsurance?active=社保设置'
          })
        }
      },
    }
  }
</script>